import { Component, Inject, Output, EventEmitter, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { ConfirmDialogComponent } from 'src/app/dialogs/confirm-dialog/confirm-dialog.component';
import { GlobalFunctions } from '@global/GlobalFunctions';
import { ILocationGroup, ILocationGroupPermissions } from '@services/organisation-data.service';

/**
 * Component
 */
@Component({
	selector: 'app-edit-security',
	templateUrl: './edit-level-permission.component.html',
	styleUrls: ['./edit-level-permission.component.scss']
})
export class EditLevelPermissionComponent {

	/** Form Group */
	dialogForm: FormGroup;

	/**
	 * Default Constructor
	 * @param fb fb
	 * @param dialogRef Referense to the Dialog box
	 * @param dialogData object interface
	 * @param globalFunctions 
	 */
	constructor(
		private fb: FormBuilder,
		public dialogRef: MatDialogRef<EditLevelPermissionComponent>,
		@Inject(MAT_DIALOG_DATA) public dialogData: ILocationGroup,
		public globalFunctions: GlobalFunctions
	) { }

	/**
	 * Page On Initialise Event Handler
	 */
	ngOnInit(): void {
		this.dialogForm = this.fb.group({
			AccountGroupID: [this.dialogData.AccountGroupID || 0],
			Name: [this.dialogData.Name || ''],
			Permissions: this.fb.array([
				this.fb.group({
				  View: [this.dialogData.Permissions[0]?.View || false],
				  Write: [this.dialogData.Permissions[0]?.Write || false]
				})
			  ])
		});
	}

	/**
	 * Cancel button for dialog
	 */
	onCancelClick(): void {
		if (this.dialogForm.dirty) {
			this.globalFunctions.UserConfirm$('Lose any unsaved changes?').subscribe(OKResult => {
				if (OKResult) { this.dialogRef.close(); }
				// do nothing if result is false
			});	
		} else {
			this.dialogRef.close();
		}
	}

}
